<template>
    <div class="filter-group">
        <label>{{ label }}</label>
        <select 
            :value="modelValue" 
            @change="$emit('update:modelValue', $event.target.value)"
            class="form-control"
        >
            <option 
                v-for="option in options" 
                :key="option.value" 
                :value="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'FilterDropdown',
    props: {
        label: {
            type: String,
            required: true
        },
        modelValue: {
            type: [String, Number],
            required: true
        },
        options: {
            type: Array,
            required: true,
            validator: (options) => {
                return options.every(option => 
                    'value' in option && 
                    'label' in option
                );
            }
        }
    },
    emits: ['update:modelValue']
}
</script>

<style scoped>
.filter-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 180px;
}

.filter-group label {
    font-size: 0.875rem;
    color: #999;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.form-control {
    padding: 0.875rem 2.5rem 0.875rem 1rem;
    border-radius: 12px;
    border: 2px solid #333;
    background: rgba(26, 26, 26, 0.8);
    color: #fff;
    font-size: 0.95rem;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1em;
    transition: all 0.2s ease;
    cursor: pointer;
}

.form-control:focus {
    border-color: #2563eb;
    outline: none;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

@media (max-width: 768px) {
    .filter-group {
        width: 100%;
    }

    .form-control {
        width: 100%;
    }
}
</style> 